import { createFileRoute } from "@tanstack/react-router";
import { WorkspaceShell } from "@/components/dravian/workspace-shell";
import { ChatPanel } from "@/components/canvas/chat-panel";

export const Route = createFileRoute("/$workspace/chat")({
  head: () => ({ meta: [{ title: "Chat — Dravian Horizon" }] }),
  component: () => (
    <WorkspaceShell>
      <div className="h-full p-3">
        <div className="mx-auto h-full max-w-[780px]">
          <ChatPanel />
        </div>
      </div>
    </WorkspaceShell>
  ),
});